import script from "./Timer.vue?vue&type=script&lang=ts&setup=true"
export * from "./Timer.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__